var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { childrenExist, createShorthandFactory, commonPropTypes, } from '../../lib';
import createComponent from '../../lib/createComponent';
/**
 * A Slot is a basic component (no default styles)
 */
var Slot = createComponent({
    displayName: 'Slot',
    className: 'ui-slot',
    propTypes: __assign({}, commonPropTypes.createCommon()),
    render: function (config, props) {
        var ElementType = config.ElementType, classes = config.classes, rest = config.rest;
        var children = props.children, content = props.content;
        return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }), childrenExist(children) ? children : content));
    },
});
Slot.create = createShorthandFactory(Slot);
export default Slot;
